<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{
        `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}新闻资讯`
      }}
    </h3>
    <!-- <el-card style="padding-left: 50px"> -->
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      label-width="120px"
      :rules="rules"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="form.title"
          placeholder="请输入"
          style="width: 400px"
          maxlength="50"
          :disabled="disabled"
        ></el-input>
      </el-form-item>
      <!-- 新闻分类 下拉  -->
      <el-form-item label="新闻分类" prop="newsClassifyId">
        <el-select
          v-model="form.newsClassifyId"
          clearable
          style="width: 400px"
          :disabled="disabled"
        >
          <el-option
            v-for="item in classifyList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上下架状态" prop="isPublish">
        <el-radio-group v-model="form.isPublish" :disabled="disabled">
          <el-radio :label="1">上架</el-radio>
          <el-radio :label="2">下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="权益等级" prop="equityClassifyIds">
        <el-checkbox-group
          v-model="form.equityClassifyIds"
          :disabled="disabled"
        >
          <el-checkbox
            v-for="item in equityClassifyList"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="是否公开" prop="isPublic">
        <el-radio-group v-model="form.isPublic" :disabled="disabled">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input
          v-model="form.intro"
          placeholder="请输入"
          style="width: 400px"
          maxlength="200"
          :disabled="disabled"
          type="textarea"
          :rows="8"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="图片" :span="8" prop="image">
        <FormImgUpload
          :url="form.image"
          @upload="uploadImg"
          :limit="1"
          :maxSize="20"
          :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
          :multiple="true"
          :disabled="disabled"
        />
        <div style="color: #c0c1c3">
          建议尺寸：330px*186px，图片格式：.png,.jpg,.jpeg,.svg,.tiff
        </div>
      </el-form-item>
      <!-- <el-form-item label="文件" prop="solutionUrl">
        <FormFileUpload
          :url="form.solutionUrl"
          @upload="upload"
          :disabled="disabled"
          :limit="1"
          :maxSize="500"
          :accept="'.pdf'"
          :multiple="true"
          :isFileName="'上传成功'"
          :showView="true"
        />
        <div style="color: #c0c1c3">文件格式：.pdf</div>
      </el-form-item> -->
      <!-- <el-form-item label="文本内容" prop="industry">
        <el-input
          v-model="form.industry"
          placeholder="请输入"
          style="width: 400px"
          maxlength="500"
          :disabled="disabled"
          type="textarea"
          :rows="8"
          show-word-limit
        ></el-input>
      </el-form-item> -->
      <el-form-item label="视频" prop="video">
        <div>
          <FormVideoUpload
            :url="form.video"
            @upload="uploadVideo"
            :limit="1"
            :maxSize="500"
            :accept="'.mp4,.webm,.avi'"
            :multiple="false"
          />
          <span style="color: #c0c1c3">
            最大500M，视频格式：.mp4,.webm,.avi
          </span>
        </div>
      </el-form-item>
      <el-form-item label="内容" :span="8" prop="content">
        <FormEditor
          :details="form.content"
          @editoChange="editoChange"
          :disabled="disabled"
          :isVideo="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button @click="revert">返回</el-button>
        <el-button type="primary" @click="submit" v-if="!disabled"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { newsInfoAdd, newsInfoUpdate, newsInfoview } from "@/api/news/info";
import { newsClassifyListAll } from "@/api/news/classify";
import { equityListClassify } from "@/api/equity/manage";
import FormEditor from "@/components/formComponents/formEditor";
import FormFileUpload from "@/components/formComponents/formFileUpload";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";

export default {
  name: "create",
  components: {
    FormEditor,
    FormFileUpload,
    FormImgUpload,
    FormVideoUpload,
  },
  data() {
    return {
      classifyList: [],
      equityClassifyList: [],
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        title: "",
        intro: "",
        image: [],
        content: "",
        video: [],
        newsClassifyId: "",
        isPublish: 1,
        equityClassifyIds: [],
        isPublic: 2,
      },
      //校验规则
      rules: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        intro: [{ required: true, message: "请输入", trigger: "blur" }],
        newsClassifyId: [
          { required: true, message: "请选择新闻分类", trigger: "blur" },
        ],
        isPublish: [
          { required: true, message: "请选择上下架状态", trigger: "change" },
        ],
        equityClassifyIds: [
          { required: true, message: "请选择权益等级", trigger: "change" },
        ],
        isPublic: [
          { required: true, message: "请选择是否公开", trigger: "change" },
        ],
        image: [
          {
            required: true,
            message: "请上传",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请上传"));
              } else {
                callback();
              }
            },
          },
        ],
        // solutionUrl: [
        //   {
        //     required: true,
        //     message: "请上传",
        //     trigger: "blur",
        //   },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length === 0) {
        //         callback(new Error("请上传"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
          {
            validator(_, value) {
              if (value) {
                if (value === "<p><br></p>") {
                  return Promise.reject(new Error("请输入内容"));
                }
                if (value.length > 65535) {
                  return Promise.reject(new Error("内容超出最大长度限制"));
                }
              }
              return Promise.resolve(true);
            },
          },
        ],
      },
      loadingSubmit: false,
    };
  },
  mounted() {
    this.getClassifyList();
    this.getEquityClassifyList();
    if (this.id) {
      this.getView();
    }
  },
  methods: {
    /**
     * 获取新闻资讯详情
     * @returns {Promise<void>}
     */
    async getView() {
      if (this.id) {
        const { data } = await newsInfoview(this.id);
        this.form = {
          ...data,
          image: data.image ? data.image.split(",") : [],
          video: data.video ? data.video.split(",") : [],
          newsClassifyId: data.newsClassifyId || data.classifyId || "",
          isPublish: data.isPublish || 1,
          equityClassifyIds: data.equityClassifyIds
            ? data.equityClassifyIds.split(",")
            : [],
          isPublic: data.isPublic || 2,
        };
      }
    },

    /**
     * 提交表单（新增/编辑新闻资讯）
     * @returns {Promise<void>}
     */
    async submit() {
      if (this.loadingSubmit) {
        return;
      }
      let newVal = {
        ...this.form,
        image: this.form.image.join(","),
        video: this.form.video.join(","),
        equityClassifyIds: this.form.equityClassifyIds.join(","),
      };

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSubmit = true;
          if (this.type == "add") {
            newsInfoAdd({
              ...newVal,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  // this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          } else {
            newsInfoUpdate({
              ...newVal,
              id: this.id,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  // this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          }
        }
      });
    },

    /**
     * 富文本框内容变化回调
     * @param {string} e - 富文本框修改后的HTML内容
     */
    editoChange(e) {
      this.form.content = e;
    },

    /**
     * 文件上传回调
     * @param {Array|string} e - 上传成功返回的文件路径或路径数组
     * @param {string} name - 文件名称
     * @param {number} size - 文件大小(KB/MB)
     */
    upload(e, name, size) {
      console.log(name, size, "name,sizename,sizename,size");

      if (Array.isArray(e)) {
        this.form.downloadUrl = [...e];
      } else {
        this.form.downloadUrl = [...this.form.downloadUrl, e];
      }
      this.form.urlName = name;
      this.form.urlSize = size ? size.toFixed(2) : "";
    },

    /**
     * 图片上传回调
     * @param {Array|string} e - 上传成功返回的图片路径或路径数组
     */
    uploadImg(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },

    /**
     * 视频上传回调
     * @param {Array|string} e - 上传成功返回的视频路径或路径数组
     * @param {string} name - 视频名称
     * @param {number} size - 视频大小
     * @param {number} duration - 视频时长
     * @param {number} index - 索引位置
     */
    uploadVideo(e, name, size, duration, index) {
      if (Array.isArray(e)) {
        this.form.video = [...e];
      } else {
        this.form.video = [e];
      }
    },

    /**
     * 获取新闻分类下拉列表
     */
    getClassifyList() {
      newsClassifyListAll({ state: 1 }).then((res) => {
        if (res.code === 200) {
          this.classifyList = res.data || [];
        }
      });
    },

    /**
     * 获取权益等级列表
     */
    getEquityClassifyList() {
      equityListClassify({}).then((res) => {
        if (res.code === 200) {
          const levels = ["L1", "L2", "L3", "L4"];
          this.equityClassifyList = (res.data || []).filter((item) =>
            levels.includes(item.name)
          );
        }
      });
    },

    /**
     * 返回上一页
     */
    revert() {
      this.$router.go(-1);
    },

    /**
     * 切换类型
     * @param {number|string} e - 类型标识
     */
    getType(e) {
      if (e == 1) {
        this.form.content = "";
      } else {
        this.form.content = [];
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-left: 30px;
  padding-right: 40%;
}
</style>
